// @ts-ignore
import tokens from '@dna/tokens/dist/json/ref/nested/tokens.json'

export const DNA = {
  variants: {
    brands: {
      blue: 'blue',
      green: 'green',
      turquoise: 'turquoise',
    },
    scales: {
      small: 'small',
      medium: 'medium',
      large: 'large',
    },
    themes: {
      light: 'light',
      dark: 'dark',
    },
  },

  tokens,
}
